import { createWebHistory, createRouter } from 'vue-router'

import HomeView from '@/views/home.vue'
import HDFHomeView from '@/views/HDFHome.vue'
import SignInView from '@/views/UserLogin.vue'
import PersonalCenterView from '@/views/PersonalCenter.vue'
import PersonalInfoView from '@/views/PersonalInfo.vue'
import PersonalRoleView from '@/views/PersonalRole.vue'
import ZhimaVideoView from '@/views/ZhimaVideo.vue'
import ZhimaSeries from '@/views/ZhimaSeries.vue'
import ZhimaSeriesListView from '@/views/ZhimaSeriesList.vue'
import AliPayResult from '@/views/AliPayResult.vue'
import WxLogin from '@/views/WxLogin.vue'
import AuthHandleView from '@/components/HDFAuthHandle.vue'
import AuthJump from '@/views/AuthJump.vue'
import ExamRegistration from '@/views/ExamRegistration.vue'
import ExamStatus from '@/views/ExamStatus.vue'
import ExamList from '@/views/ExamList.vue'
import ExamHistory from '@/views/ExamHistory.vue'

const routes = [
    // 首页（新版 UI，2026-08 甲方新设计）
    { path: '/', component: HomeView },
    // 旧版首页，暂时保留备用
    { path: '/home-old', component: HDFHomeView },
    // 登陆
    { path: '/signIn', component: SignInView },
    // 处理微信登陆回调
    { path: '/wxLogin', component: WxLogin },
    // 个人中心，新，个人资料设置
    { path: '/personalInfo', component: PersonalInfoView },
    // 个人会员等级
    { path: '/personalRole', component: PersonalRoleView },
    // 智码课程详情
    { path: '/zms', component: ZhimaSeries },
    // 文章
    { path: '/article/:code', name: 'ArticleDetail', component: () => import ('@/views/ArticleDetail.vue') },
    // 智码课程列表
    { path: '/zmsl', component: ZhimaSeriesListView },
    // 第三方跳转到该系统的逻辑处理页
    { path: '/auth/handle', component: AuthHandleView },
    //跳转获取token界面
    { path: '/auth/jump', component: AuthJump },
    // 支付二维码展示
    { 
        path: '/wxPay', component: () =>
        import ('@/views/HDFPay.vue') 
    },
    // 支付宝支付FormHtml承载页面
    { path: '/alipay', component: () =>
            import ('@/views/AliPayx.vue') },
    // 支付宝支付成功回跳页面
    {
        path: '/pay/aliPayResult',
        name: 'AliPayResult',
        component: AliPayResult
    },
    // 注册已关闭：账号统一由后台/代理商创建，老注册地址重定向到登录页
    { path: '/signUp', redirect: '/signIn' },
    // 个人中心，旧 UI
    { path: '/personalCenter', component: PersonalCenterView },
    // 智码，视频列表，旧 UI
    { path: '/zmv', component: ZhimaVideoView }
    ,{
        path: '/exam-registration',
        name: 'ExamRegistration',
        component: ExamRegistration
    },
    {
        path: '/exam-status',
        name: 'ExamStatus',
        component: ExamStatus
    },
    {
        path: '/exam-list',
        name: 'ExamList',
        component: ExamList
    },
    {
        path: '/exam-history',
        name: 'ExamHistory',
        component: ExamHistory
    },
    // 题库评测入口界面，无需登录即可访问
    {
        path: '/scoring-start',
        name: 'ScoringStart',
        component: () => import('@/views/ScoringStart.vue'),
        meta: { requiresAuth: false }
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
